/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { Button, Card as CardMui, CardContent, Typography, LinearProgress, Box, Icon, Tooltip, IconButton, CircularProgress, Avatar, Switch, FormGroup, FormControlLabel, Collapse } from '@mui/material';
import { colors } from '../../../utils';
import Table from '../../../components/table/Table';
import { styled } from '@mui/styles';
import { Api } from '../../../api/api';
import { endPoints } from '../../../api/apiEndpoints';
import { setAllCompanies } from '../../../redux/slices/companies/companies';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import CustomUploadFile from '../../../components/input/UploadImage';
import { errorNotify, successNotify } from '../../../utils/helper';
import EditIcon from '@mui/icons-material/Edit';

const styles = {
	card: {
		padding: '5px', // Adjust padding as needed
		margin: '20px', // Adjust margin as needed
		textAlign: 'center', // Center align text
		boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
	},
	hr: {
		margin: '10px 0', // Adjust margin as needed
	},
};

const CompanyProfile = () => {
	const dispatch = useDispatch();
	const { colorWhite, colorPrimary, colorGreenGradient } = colors;
	const { companies } = useSelector((state) => state?.companies);
	const navigate = useNavigate();
	const [openModal, setOpenModal] = useState(false);
	const [formData, setFormData] = useState({
		email: '',
		number: '',
		address: '',
		logo: '',
		company_name: '',
		ntn: '',
		landline_number: '',
		enabled: false
	});
	const [selectedFile, setSelectedFile] = useState(null);
	const [isFilePicked, setIsFilePicked] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [imageShow, setImageShow] = useState([]);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);
	const [activeCustomers, setActiveCustomers] = useState('00');
	const [inactiveCustomers, setinactiveCustomers] = useState('00');
	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});


	const handleCloseModal = () => {
		setIsEditing(false)
		setOpenModal(false);
		setFormData({
			email: '',
			number: '',
			address: '',
			logo: '',
			company_name: '',
			ntn: '',
			landline_number: '',
			enabled: false,
		})
	}

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleEditModal = (e, val) => {
		e.stopPropagation();
		setIsEditing(true)
		setOpenModal(val)
		const { email, number, address, logo, company_name, ntn, landline_number, enabled, id } = val;
		setFormData({ email, number, address, logo, company_name, ntn, landline_number, enabled, id });
	};

	const handleChangeSwitch = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.checked,
		}));
	};

	const handleSwitchClick = (event) => {
		event.stopPropagation();
	};
	const handleChangeTableSwitch = async (event, val) => {
		const { email, number, address, logo, company_name, ntn, landline_number, id } = val;
		let data = {
			email, number, address, logo, company_name, ntn, landline_number, id,
			enabled: event.target.checked,
		};

		await Api.post(endPoints?.client?.update, {
			...data,
			"host": "localhost",
		}, {
			headers: {
				'xt-user-token': null
			}
		})
			.then((response) => {
				handleCloseModal();
				getAllCompanies();
				getClientsCount();
				successNotify("Account Status Updated Successfully")


			})
			.catch((error) => {
				if (error?.response?.status === 400) {
					errorNotify(error?.response?.data);
				}
			});

	};
	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		// {
		// 	title: 'Category Id',
		// 	field: 'category_id',
		// 	render: (rowData) => <h4 className='font-face-B'>{rowData?.category_id}</h4>,
		// },
		{
			title: 'Company',
			field: 'company_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.company_name}</h4>,
		},
		{
			title: 'Email',
			field: 'email',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.email}</h4>,
		},
		{
			title: 'Number',
			field: 'number',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.number}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Status',
			field: 'enabled',
			render: (rowData) =>
				<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, rowData)} checked={rowData?.enabled} name='enabled' />,
		},

		// {
		// 	title: 'enabled',
		// 	field: 'enabled',
		// 	render: (rowData) => <h4 className='font-face-R'>{rowData?.enabled ? <Icon color='success' className="text-green text-16">check_circle</Icon> : <Icon className="text-red text-16">cancel</Icon>}</h4>,
		// },
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={(event) => handleEditModal(event, rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},

	];

	const getAllCompanies = async (limit, page) => {
		setIsLoading(true)
		try {
			await Api.post(endPoints?.companies?.list, {
				"limit": limit || 10,
				"page": page || 1,
				"columns": "*",
				"sortby": "ASC",
				"orderby": "id",
				"where": "id ^!= ^$1 AND displayed = false order by id",
				"values": 0
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllCompanies(
							response?.data?.data?.clients?.clients?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								// category_id: d?.category_id,
								company_name: d?.company_name,
								email: d?.email,
								number: d?.number,
								dt: d?.dt,
								enabled: d?.enabled,
								landline_number: d?.landline_number,
								logo: d?.logo,
								ntn: d?.ntn,
								address: d?.address,
							})
							),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.clients?.pagination;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false)
				})
				.catch((error) => {
				});

		} catch (error) {
		}
	};
	const getClientsCount = async () => {
		setIsLoading(true)
		try {
			const response = await Api?.get(endPoints?.companies?.count, {
				headers: {
					'xt-user-token': null
				}
			});
			setActiveCustomers(response.data.data?.clients?.active_clients?.active)
			setinactiveCustomers(response.data.data?.clients?.inactive_clients?.inactive)
			// dispatch(
			// 	setAllClientsCount(
			// 		response?.data?.data?.clients?.clients?.map((d, index) => ({
			// 			index: index + 1,
			// 			id: d?.id,
			// 			company_name: d?.company_name,
			// 			email: d?.email,
			// 		})
			// 		),
			// 	),
			// );
			setIsLoading(false)

		} catch (error) {
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsLoadingModal(true)
		if (!isEditing) {

			try {

				await Api.post(endPoints?.client?.onboarding, {
					...formData,
				}, {
					headers: {
						'xt-client-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getAllCompanies();
						successNotify("Account Created Successfully")
						setIsLoadingModal(false)


					})
					.catch((error) => {
						if (error?.response?.status === 400) {
							errorNotify(error?.response?.data);
						}
					});
			} catch (error) {
				if (error?.response?.data) {
					errorNotify(error?.response?.data?.message);
				}
			}
		} else {


			try {

				await Api.post(endPoints?.client?.update, {
					...formData,
					"host": "localhost",
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getAllCompanies();
						getClientsCount();
						successNotify("Account Updated Successfully")
						setIsLoadingModal(false)


					})
					.catch((error) => {
						if (error?.response?.status === 400) {
							errorNotify(error?.response?.data);
						}
					});
			} catch (error) {
				if (error?.response?.data) {
					errorNotify(error?.response?.data?.message);
				}
			}




		}
	};

	const handleImageUpload = (event) => {
		setIsLoadingImg(true)
		if (event.target.files.length > 0) {
			let formData = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formData.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingImg(false)
					setFormData((prevState) => ({
						...prevState,
						logo: response.data.data.link,
					}));
					successNotify("Image Uploaded Successfully");

				})
				.catch((error) => {

				});

		}


	};

	useEffect(() => {
		getAllCompanies();
		getClientsCount();
	}, [])

	return (
		<>
			<Card margin='3rem 1.5rem' padding='3rem'>
				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>

					<ButtonCom btnTitle='Create Account' onClickHandler={() => setOpenModal(true)} />

					<TransitionsModal
						open={openModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? 'Update' : 'Onboarding'}
						isLoading={isLoadingModal}
					// submitHandler={leaveApprovedHandler}
					// submitDisabledBtn={leaveApprovedDis}
					>

						{isLoadingImg ?
							<Box sx={{ display: "flex", justifyContent: "center" }}>
								<CircularProgress color="success" />
							</Box>
							:
							<>
								<input
									// accept="image/*"
									accept=".jpeg, .jpg, .png"
									style={{ display: 'none' }}
									id="image-upload"
									type="file"
									onChange={(event) => handleImageUpload(event)}
								/>
								<label htmlFor="image-upload">
									<Button
										variant="contained"
										component="span"
										color='success'
										style={{ width: '30%', margin: '1em auto', fontSize: "1em", display: "flex" }}
									>
										Upload Profile
									</Button>
								</label>

							</>}
						{formData?.logo &&
							<Avatar sx={{ width: 56, height: 56, margin: "1em auto" }} alt="icon" src={formData?.logo} />
						}


						<Grid gtc='repeat(auto-fit, minmax(35rem, 1fr))' margin='2.5rem 0' padding='2rem'>

							<MarginHandler width='100%'>
								<InputControl
									state={formData?.company_name}
									onChange={handleChange}
									label='Company Name'
									name='company_name'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.email}
									onChange={handleChange}
									label='Email'
									name='email'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.number}
									onChange={handleChange}
									label='Phone Number'
									name='number'
								/>
							</MarginHandler>

							<MarginHandler width='100%'>
								<InputControl
									state={formData?.address}
									onChange={handleChange}
									label='Address'
									name='address'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.ntn}
									onChange={handleChange}
									label='NTN'
									name='ntn'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.landline_number}
									onChange={handleChange}
									label='Landline Number'
									name='landline_number'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<FormGroup>
									<FormControlLabel control={<Switch onChange={handleChangeSwitch} checked={formData?.enabled} name='enabled' />} label="Enable" />
								</FormGroup>
							</MarginHandler>

							<MarginHandler mt="2rem">
								<Button
									color='primary'
									variant='contained'
									onClick={handleSubmit}
									style={{
										background: colorGreenGradient,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '0.7rem 2rem',
										color: colorWhite,
										borderRadius: '0.5rem',
										float: "right"
									}}
									className='font-face-R'>
									Submit
								</Button>
							</MarginHandler>

						</Grid>
					</TransitionsModal>
				</Flex>
				<Grid
					gtc='repeat(auto-fit, minmax(35rem, 1fr))' margin='1rem 0' padding='0rem'>

					<CardMui style={styles.card}>
						<CardContent>
							<Typography className='font-face-M' variant="h5" component="div">
								{activeCustomers}
							</Typography>
							<hr style={styles.hr} />
							<Typography className='font-face-M' variant="h5" color="text.secondary">
								Active Customers
							</Typography>
						</CardContent>
					</CardMui>
					<CardMui style={styles.card}>
						<CardContent>
							<Typography className='font-face-M' variant="h5" component="div">
								{inactiveCustomers}
							</Typography>
							<hr style={styles.hr} />
							<Typography className='font-face-M' variant="h5" color="text.secondary">
								Inactive Customers
							</Typography>
						</CardContent>
					</CardMui>
				</Grid>
				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={companies?.map((item) => ({ ...item }))}
						sorting
						onClickRow={(rowData) => {
							navigate(
								'/company-details',
								{
									state: {
										rowData
									}
								}
							)
						}}
						columnsButton
						padding="3rem"
						showTitle
						paginationType='normal'
						titleHeading='Business Accounts'
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getAllCompanies(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getAllCompanies(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				}
			</Card>
		</>
	);
};

export default CompanyProfile;
